module.exports = __webpack_public_path__ + "img/paarfoto_antrag_ocular.b4381fb7.jpg";